import React, { useState } from "react";
import { debounce } from "lodash";
import axios from "axios";
import { StyledSpinner } from "./SignupStep2";
import { useRef } from "react";
import styled from "styled-components";
import { FormRowMessage, FormTextbox, FormRow } from "fiver-react-ui-components";
const StyledAddressSelection = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 5px;
  background-color: #f3f3f3;
  margin-bottom: 5px;
  padding: 5px;
  font-size: 14px;
`;
const StyledDropdownWrapper = styled.div`
  overflow: hidden scroll;
  width: 100%;
  max-height: ${props => props.dropdownOpen ? "300px" : "0px"};
  transition: max-height 0.5s;
  margin-top: ${props => props.dropdownOpen ? "1rem" : "0rem"};
`;
const StyledDropdownContent = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
`;

const AddressLookup = ({
  translations,
  values,
  errors,
  handleChange,
  handleBlur,
  setFieldTouched,
  setFieldValue,
  colorPrimary,
  touched
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [listOfAddresses, setListOfAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [asyncPostCodeError, setAsyncPostCodeError] = useState(undefined);
  const [postCodeLoading, setPostCodeLoading] = useState(false);

  const populateAddressFields = async address => {
    await setFieldValue("street1", address.line1);
    await setFieldValue("street2", address.line2);
    await setFieldValue("city", address.city);
    await setFieldValue("county", address.county);
    await setFieldValue("country", address.country);
    await setFieldValue("postcode", address.postcode);
    setSelectedAddress(address);
    setDropdownOpen(false);
  };

  const handlePostCodeLookup = async (e, callback) => {
    const {
      value,
      name
    } = e.target;
    const postcode = value.replace(/\s/g, "");

    if (postcode.length >= 5 && postcode.length <= 8) {
      setPostCodeLoading(true);
      setDropdownOpen(false);
      setSelectedAddress(undefined);

      if (postcode !== values.postcode) {
        await axios.get(`/address-lookup/postcode/${postcode}`).then(({
          data
        }) => {
          setPostCodeLoading(false);
          setAsyncPostCodeError(undefined);
          setListOfAddresses(data?.data);
          setDropdownOpen(true);
        }).catch(() => {
          setPostCodeLoading(false);
          setAsyncPostCodeError(translations.postcodeDoesntExist);
          setFieldValue("street1", "");
          setFieldTouched("street1", true, true);
          setFieldValue("street2", "");
          setFieldValue("city", "");
          setFieldTouched("city", true, true);
          setFieldValue("county", "");
        });
      }
    }

    callback(name, true, true);
  };

  const refHandler = useRef(debounce(handlePostCodeLookup, 350));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    name: "postcode",
    placeholder: translations.postcode,
    value: values.postcode,
    isRequired: true,
    validateOnChange: true,
    isError: touched.postcode && errors.postcode,
    onChange: e => {
      handleChange(e);
      refHandler.current(e, setFieldTouched);
    },
    onBlur: e => {
      handleBlur(e);
    }
  }), postCodeLoading && /*#__PURE__*/React.createElement(StyledSpinner, {
    colorPrimary: colorPrimary,
    lineWidth: 5
  })), /*#__PURE__*/React.createElement(StyledDropdownWrapper, {
    dropdownOpen: dropdownOpen
  }, /*#__PURE__*/React.createElement(StyledDropdownContent, null, listOfAddresses.map(address => /*#__PURE__*/React.createElement(StyledAddressSelection, {
    key: address?.line1 + address?.line2,
    type: "button",
    onClick: () => {
      populateAddressFields(address);
    }
  }, address?.line1, ", ", address?.line2)))), selectedAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "street1",
    isError: values.street1 !== "" && errors.street1,
    value: values.street1,
    placeholder: "Address Line 1",
    disabled: true
  }))), values.street1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "street2",
    value: values.street2,
    placeholder: "Address Line 2",
    disabled: true
  })), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isRequired: true,
    onChange: handleChange,
    onBlur: handleBlur,
    name: "city",
    isError: values.city !== "" && errors.city,
    value: values.city,
    placeholder: "City / Town",
    disabled: true
  })), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "county",
    value: values.county,
    placeholder: "County",
    disabled: true
  }))), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: !errors.postcode && asyncPostCodeError
  }, asyncPostCodeError));
};

export default AddressLookup;